import React, { FC, HTMLProps, useState } from 'react';
import AppContext from '../../../../../libs/AppContext';

type Props = {
  image: string;
  name?: string;
  username: string;
  url?: string;
} & HTMLProps<HTMLDivElement>;
const Photo: FC<Props> = ({ image, name, username, url, ...props }) => {
  const [isShow, setIsShow] = useState(false);
  return (
    <div
      css={{
        cursor: 'pointer',
        position: 'relative',
      }}
      {...props}
      onMouseOut={() => setIsShow(false)}
      onMouseOver={() => setIsShow(true)}
    >
      <img css={{
        width: '100%'
      }} loading="lazy" src={image} />
      {AppContext.isAdmin && url &&(
        <button css={{
          background: '#d6d6d6',
          padding: 5,
          width: '100%'
        }} onClick={() => {
          window.open(url, '_blank').focus();
        }}>image link</button>
      )}
    </div>
  );
};

export default Photo;
